import Vue from 'vue'
import Vuex from 'vuex'
import {actions} from './actions'
import {mutations} from './mutations'
import _ from 'lodash'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  strict: debug,
  state: {
    alerts: {},
    items: {},
    shipment: {internal_name: '', cost: 0},
    payment: {internal_name: ''},
    discount: {},
    order_id: 0,
    shipments: [],
    payments: [],
    approvedProcessing: false,
    approvedMarketing: false,
    approvedMailing: false,
    comment: "",
    addresses: {
      billing: {},
      shipping: {}
    },
  },
  actions,
  mutations,

  getters: {

    alerts(state) {
      return state.alerts;
    },
    items(state) {
      return state.items;
    },

    comment(state) {
      return state.comment;
    },
    payment(state) {
      return state.payments;
    },
    shipment(state) {
      return state.shipment;
    },
    shipmentCost(state) {
      return state.shipment.cost;
    },
    discount(state) {
      return state.discount;
    },

    discountValue(state) {
      let dv = 0;
      let itemsTotal = 0;
      _.forEach(state.items, item => {
        itemsTotal += item.qty * item.price;
      });

      if ('discount_amount' in state.discount && state.discount.discount_amount > 0) {
        dv = Math.abs(parseInt(state.discount.discount_amount));
      } else if ('discount_percentage' in state.discount && state.discount.discount_percentage > 0) {

        let prc = Math.abs(parseInt(state.discount.discount_percentage));
        if (prc > 0 && prc < 100) {
          dv = itemsTotal * prc / 100;
        }
      }
      return dv;
    },

    shipments(state) {
      return state.shipments;
    },
    payments(state) {
      return state.payments;
    },
    indicator(state) {
      if (typeof state.items === 'object') {
        return Object.keys(state.items).length;
      } else return 0;

    },
    itemsTotal(state) {

      let total = 0;
      _.forEach(state.items, item => {
        total += item.qty * item.price;
      });

      return total;
      //return state.order.total;
    },
    billingAddress(state) {
      return state.addresses.billing;
    },
    shippingAddress(state) {
      return state.addresses.shipping;
    },
    addresses(state) {
      return state.addresses;
    },
    approvedProcessing(state) {
      return state.approvedProcessing;
    },
    approvedMarketing(state) {
      return state.approvedMarketing;
    },
    approvedMailing(state) {
      return state.approvedMailing;
    }
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js